export default "__VITE_ASSET__5TvSK70C__"